itsoftApp.createModule("switchEffect", function () {
    var module = this;

    var initSwitchEffect = function () {
        const buttonsSwitch = document.querySelectorAll('.js-switch');

        function activateSwitch(el) {
            if (el.checked) {
                el.closest('.js-switch-container').classList.add('_switched');
                return true;
            }
            el.closest('.js-switch-container').classList.remove('_switched');
            return false;
        }
        if (buttonsSwitch) {
            for (let index = 0; index < buttonsSwitch.length; index++) {
                const button = buttonsSwitch[index];
                button.addEventListener('click', function() {
                    activateSwitch(button);
                })
                activateSwitch(button);
            }
        }
    };

    initSwitchEffect();

    module.callback = initSwitchEffect;
});